export const PortsIn = {
  position: {
    name: "left",
  },
  attrs: {
    portBody: {
      magnet: true,
      r: 6,
      fill: "#023047",
      stroke: "#023047",
    },
  },
  label: {
    position: {
      name: "left",
      args: { y: 6 },
    },
    markup: [
      {
        tagName: "text",
        selector: "label",
        className: "label-text",
      },
    ],
  },
  markup: [
    {
      tagName: "circle",
      selector: "portBody",
    },
  ],
};
